export enum BuildingActionsEnum {
  Viewfloors = 1,
  Edit,
  Open,
  Close,
  Delete,
  Archive,
  Unarchive,
  Publish,
  Unpublish
}
